import moment from 'moment';
import queryString from 'query-string';
import { createLogic } from 'redux-logic';

import { ALTITUDES, getGridApiBaseUri } from '../../config/config-base';

import {
  CLOUD_XHR_DISPATCH,
  CLOUD_XHR_CANCEL,
  CLOUD_XHR_ERROR,
  CLOUD_XHR_SUCCESS,
} from '../actions/cloud';

const cloudRequestEpic = createLogic({
  type: CLOUD_XHR_DISPATCH,
  cancelType: CLOUD_XHR_CANCEL,
  latest: true,

  processOptions: {
    dispatchReturn: true,
    successType: CLOUD_XHR_SUCCESS,
    failType: CLOUD_XHR_ERROR,
  },

  process({ getState, action, ajax }) {
    let { init, time, latlngs } = action.payload;

    let settings = {
      crossDomain: true,
      responseType: 'json',
      url:
        `${getGridApiBaseUri()}/cross_section?` +
        queryString.stringify({
          name: 'icon1_ch_icing_aircraft',
          params: ALTITUDES.map((altitude) => `C_${altitude}m`).join(','),
          init: moment.utc(init).format('YYYY-MM-DD HH:mm:ss'),
          time: moment.utc(time).format('YYYY-MM-DD HH:mm:ss'),
          lats: latlngs.map((latlng) => latlng.lat).join(','),
          lons: latlngs.map((latlng) => latlng.lon).join(','),
        }),
    };

    return ajax(settings);
  },
});

const cloudEpic = [cloudRequestEpic];

export default cloudEpic;
